import { render, staticRenderFns } from "./CardShortlist.vue?vue&type=template&id=0382738b&"
import script from "./CardShortlist.vue?vue&type=script&lang=js&"
export * from "./CardShortlist.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports